import { render, staticRenderFns } from "./BrandSeoPickerPanel.vue?vue&type=template&id=655c94ce&scoped=true"
import script from "./BrandSeoPickerPanel.vue?vue&type=script&lang=js"
export * from "./BrandSeoPickerPanel.vue?vue&type=script&lang=js"
import style0 from "./BrandSeoPickerPanel.vue?vue&type=style&index=0&id=655c94ce&prod&scoped=true&lang=css"
import style1 from "./BrandSeoPickerPanel.vue?vue&type=style&index=1&id=655c94ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655c94ce",
  null
  
)

export default component.exports